import React from 'react';
import { Search, X } from 'lucide-react'; // Import both Search and X icons

const SearchBar = ({ value, onChange, onClear }) => {
  return (
    <div className="relative">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search topics..."
        className="w-full px-4 py-2 pl-10 pr-10 border border-neutral-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-neutral-500 focus:border-neutral-500 bg-neutral-50"
      />
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-neutral-500" size={18} />
      {value && (
        <button
          onClick={onClear}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-neutral-500 hover:text-neutral-700"
          aria-label="Clear search"
        >
          <X size={18} />
        </button>
      )}
    </div>
  );
};

export default SearchBar;
